import { useEffect } from 'react'

export function useSendIframeHeight(active: boolean = true) {
	useEffect(() => {
		if (active) {
			function sendHeight() {
				const height = document.documentElement.clientHeight
				parent.postMessage({ type: 'setHeight', height }, '*')
			}

			sendHeight()

			const observer = new MutationObserver(sendHeight)

			observer.observe(document.body, {
				attributes: true,
				childList: true,
				subtree: true,
			})

			window.addEventListener('resize', sendHeight)

			return () => {
				observer.disconnect()
				window.removeEventListener('resize', sendHeight)
			}
		}
	}, [])
}
